import { render, staticRenderFns } from "./ExchangePartner.vue?vue&type=template&id=3579fd59&"
import script from "./ExchangePartner.vue?vue&type=script&lang=js&"
export * from "./ExchangePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports